// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, [96], function() { return __webpack_require__("./src/styles.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, [96], function() { return __webpack_require__("./node_modules/material-design-iconfont/style.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
